import React from 'react';
import NotificationsList from './NotificationsList';
import groupsSearchItem from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';
import groupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector/index';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent/index';
import NotificationsRightSidebar from './NotificationsRightSidebar/index';

const GroupsSearchItem = ColumnsContent(
  groupsSearchCollector(groupsSearchItem(NotificationsList)),
  NotificationsRightSidebar
);

export default props => (
  <GroupsSearchItem
    {...props}
    groupName="notices"
    listReduceName="eventsModule.lists.eventsUserNoticesList"
  />
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationsList/index.js